"use client";

// Direct import keeps the auth barrel's pages out of every export wizard.
import { useAuth } from "@/features/auth/hooks/use-auth";

import { DEFAULT_EXPORT_THEME, type ExportTheme } from "./types";

/** The document theme saved on the user's account, which export wizards
 * pre-select. Falls back to the default until /me resolves. */
export function usePreferredExportTheme(): ExportTheme {
  return useAuth().user?.document_theme ?? DEFAULT_EXPORT_THEME;
}
